import { render, staticRenderFns } from "./AddressTitle.vue?vue&type=template&id=1836e131"
import script from "./AddressTitle.vue?vue&type=script&lang=js"
export * from "./AddressTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports